import React, {useState} from 'react'
import {
  Box,
  Typography,
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Rating,
  Link as MuiLink
} from "@mui/material";
import { Link} from 'react-router-dom';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
import ReplyCard from './ReplyCard';
import UpdateReplyModal from './forms/UpdateReplyModal';
import AddReplyModal from './forms/AddReplyModal';
import UpdateReviewForm from './forms/UpdateReviewForm';

export default function ReviewPopup({ review , canUpdateReply, reload, setReload, issue = {},canReply, canUpdateReview}) {
  

    const [open, setOpen] = useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    if (!review) return null;

  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
        sx={{
          color: "#0a7d40",
          fontWeight: 600,
          textTransform: "none",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        Read More
      </Button>
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionProps={{ timeout: 400 }}
      PaperProps={{
        sx: {
          borderRadius: 4,
          backgroundColor: "#f0fff4", // solid green background
        },
      }}
    >
      
      <DialogContent dividers sx={{ position: "relative" }}>
        <Button
          onClick={handleClose}
          sx={{
            position: "absolute", // 👈 correctly positions relative to DialogContent
            top: 8,
            right: 8,
            minWidth: "auto",
            padding: "4px 8px",
            fontSize: "1.2rem",
            lineHeight: 1,
          }}
        >
          ❌
        </Button>
        {/* User */}
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          
          <Avatar src={review.user.profile ||
                      'https://picsum.photos/1017/917'} alt={review.user.name} />
          <Box>
            <Typography fontWeight={600}>{review.user.name}</Typography>
            <Typography variant="caption" color="text.secondary">
              {new Date(review.timestamp).toLocaleString()}
            </Typography>
            <br/>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1}}>
                🔗
                <MuiLink
                  component={Link}
                  to={`/issues/${review.issue_id}`}
                  underline="hover"
                  color="primary"
                  sx={{ fontWeight: 300 }}
                >
                  Reported Issue ({review.issue_status || 'Open'})
                </MuiLink>                
              </Typography>
          </Box>
        
        </Box>

        {/* Rating */}
        <Rating value={review.rating} readOnly size="medium" />

        {/* Review text */}
        <Typography variant="body1" mt={2} whiteSpace="pre-line" sx={{fontFamily:'Lato', fontStyle:'italic'}}>
          <FaQuoteLeft style={{ marginRight: 6, color: '#43a047', fontSize: 11 }} />          
          {review.review_text}
                    {'  '}
          <FaQuoteRight style={{ marginRight: 6, color: '#43a047', fontSize: 11}} />
        </Typography>
        <DialogActions>
          {canReply && (
          <AddReplyModal review={review} reload={reload} setReload={setReload}/>
          )}
          {canUpdateReview && (
            <UpdateReviewForm review={review} reload={reload} setReload={setReload} />
          )}
        </DialogActions>

        {/* Reply if available */}
        {review.reply && (
          <ReplyCard review={review} canUpdateReply={canUpdateReply} reload={reload} setReload={setReload} issue={issue}/>
        )}
        {canUpdateReply &&(
          <DialogActions>
            <UpdateReplyModal reload={reload} setReload={setReload} currentReply={review?.reply?.reply_text} review={review} />
          </DialogActions>
        )}
      </DialogContent>
      
    </Dialog>
    </>
  );
};
